// extracted by mini-css-extract-plugin
export default {"svg":"style_svg__S2-Cu","wrapper":"style_wrapper__fOZs7","backWrapper":"style_backWrapper__f31Ve","backItemWrapper":"style_backItemWrapper__CdKnV","backText":"style_backText__I0-Yy"};